import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { DealerActions } from 'src/app/common/store/actions/dealer.actions';
import { selectAllCarImagesFolders, selectCustomerCarsByBusinessLine, selectDealerProfile, selectDealerFetchingResults } from 'src/app/common/store/state/app.state';
import { Dealer } from 'src/app/public/account/models/dealer.model';
import { CarBusinessLine } from 'src/app/public/car/constants/car-basic-data';
import { Car } from 'src/app/public/car/models/car.model';
import { ObjectSource } from 'src/app/public/common/constants/general-basic-data';
import { FileData } from 'src/app/public/common/models/file-data.model';

@Component({
    selector: 'app-customer-rent-favorites',
    templateUrl: './customer-rent-favorites.component.html',
    styleUrl: './customer-rent-favorites.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CustomerRentFavoritesComponent {

  myRentCars$: Observable<Car[]>;
  carImagesFolders$: Observable<Map<string, Array<FileData>>>;
  myProfile$: Observable<Dealer>;
  businessLine: CarBusinessLine = CarBusinessLine.RENT;
  objectSource: ObjectSource = ObjectSource.RENT

  fetchingResults$: Observable<boolean>;

   constructor(
  
      private store: Store, 
      private router: Router
      ) {

        this.fetchingResults$ = store.select(selectDealerFetchingResults);
  
        this.carImagesFolders$ = store.select(selectAllCarImagesFolders);
  
        this.myProfile$ = store.select(selectDealerProfile);
  
        this.myRentCars$ = store.select(selectCustomerCarsByBusinessLine(this.businessLine))
  
      }
  
      ngOnInit() {
        this.store.dispatch(DealerActions.fetchCustomerCarsSubmit({businessLine: this.businessLine, favoritesOnly: true}));
    }

}
